class TimelineBttns {
  constructor() {
    this.timelineContainer = document.getElementById('timeline-container');
    this.btnForward = document.getElementById('btn--timeline-forward');
    this.btnBack = document.getElementById('btn--timeline-back');


    if (!this.timelineContainer || !this.btnForward || !this.btnBack) {
      return false;
    }

    this.btnForward.addEventListener('click', this.scrollForward)

    this.btnBack.addEventListener('click', this.scrollBack)
  }

  scrollForward = () => {
    this.timelineContainer.scrollBy({ left: 300, behavior: 'smooth' })
  }

  scrollBack = () => {
    this.timelineContainer.scrollBy({ left: -300, behavior: 'smooth' })
  }
}

new TimelineBttns()
